import { render, staticRenderFns } from "./GameSettings.vue?vue&type=template&id=5739446a&scoped=true&"
import script from "./GameSettings.vue?vue&type=script&lang=js&"
export * from "./GameSettings.vue?vue&type=script&lang=js&"
import style0 from "./GameSettings.vue?vue&type=style&index=0&id=5739446a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5739446a",
  null
  
)

export default component.exports